export const toCamelCase = (str: string): string => {
   if (!str) return "";

   return (
      str
         // Normalize unicode characters
         .normalize("NFKD")
         // Remove combining diacritical marks
         .replace(/[\u0300-\u036F]/g, "")
         // Remove control characters
         .replace(/[\u0000-\u001f]/g, "")
         // Replace special characters and spaces with single space
         .replace(/[\s~`!@#$%^&*()\-_+=[\]{}|\\;:"'""''–—<>,.?/]+/g, " ")
         // Trim whitespace
         .trim()
         // Split by spaces and convert to camelCase
         .split(/\s+/)
         .map((word, index) => {
            if (index === 0) {
               // First word: lowercase
               return word.toLowerCase();
            } else {
               // Subsequent words: capitalize first letter, lowercase rest
               return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            }
         })
         .join("")
   );
};
